import React from "react";
import "./TransferHistoryTab.sass";

// --- MOCK DATA ---
const mockTransfers = [
  {
    id: 1,
    time: "2026-01-03, 02:44:40",
    coin: "USDT",
    amount: "342,480.50991800",
    from: "Fiat and Spot",
    to: "Lead Trading",
  },
  {
    id: 2,
    time: "2026-01-03, 02:44:40",
    coin: "USDT",
    amount: "42,480.50991800",
    from: "Lead Trading",
    to: "Fiat and Spot",
  },
  {
    id: 3,
    time: "2025-12-31, 07:08:00",
    coin: "USDT",
    amount: "10,000.00000000",
    from: "Fiat and Spot",
    to: "Fiat and Spot",
  },
  {
    id: 4,
    time: "2026-01-03, 02:44:40",
    coin: "USDT",
    amount: "342,480.50991800",
    from: "Fiat and Spot",
    to: "Lead Trading",
  },
  {
    id: 5,
    time: "2025-12-17, 01:22:17",
    coin: "USDT",
    amount: "400,000.00000000",
    from: "Lead Trading",
    to: "Fiat and Spot",
  },
  {
    id: 6,
    time: "2025-12-04, 04:20:12",
    coin: "USDT",
    amount: "102,480.50991800",
    from: "Fiat and Spot",
    to: "Fiat and Spot",
  },
  {
    id: 7,
    time: "2025-12-04, 04:11:52",
    coin: "USDT",
    amount: "552,480.50991800",
    from: "Fiat and Spot",
    to: "Lead Trading",
  },
];

export const TransferHistoryTab = () => {
  return (
    <div className="transfer-history">
      <div className="transfer-history__content-wrapper">
        <table className="transfer-history__table">
          <thead>
            <tr>
              <th>Time</th>
              <th>Coin</th>
              <th>Amount</th>
              <th>From</th>
              <th>To</th>
            </tr>
          </thead>
          <tbody>
            {mockTransfers.map((item) => (
              <tr key={item.id}>
                <td>{item.time}</td>
                <td>{item.coin}</td>
                <td>{item.amount}</td>
                <td>{item.from}</td>
                <td>{item.to}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
